//frontend/src/hooks/useLiveBuses.js

import { useState } from 'react';
import { useRegion } from '../contexts/RegionContext';
import { usePolledResource } from './usePolledResource';

export function useLiveBuses(routeId) {
  const { adapter } = useRegion();
  const [lastUpdated, setLastUpdated] = useState(null);
  const active = Boolean(routeId);

  const { data, loading, error } = usePolledResource(
    () => adapter.fetchLiveBuses(routeId),
    [routeId, adapter],
    {
      enabled: active,
      refetchInterval: 30000,
      initialData: [],
      onSuccess: () => setLastUpdated(new Date()),
    }
  );

  return {
    buses: Array.isArray(data) ? data : [],
    loading,
    error,
    lastUpdated,
  };
}